<template>
    <div class="colorGrey" v-if="loggedInUser.position && loggedInUser.position.role === 'manager'">
      <v-flex xs12 md6 m0a text-xs-center >
        <v-flex xs12>
          <h1 class="colorPink">Sales Data Export</h1>
          <label><h2>1. Sales Data</h2></label>
          <v-radio-group
            v-model="salesData"
            row
            class="radio-center"
          >
            <v-radio
              label="Online"
              value="online"
            ></v-radio>
            <v-radio
              label="Offline"
              value="offline"
            ></v-radio>
            <v-radio
              label="Both"
              value="both"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12>
          <label><h2>2. Team Members</h2></label>
          <v-select
            style="max-width: 360px; margin: 0 auto;"
            v-model="teamMembers"
            :items="availableUsers"
            label="Team Members"
            item-value="id"
            item-text="firstName"
            multiple
            chips clearable
            menu-props="bottom"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <label><h2>3. Date Range</h2></label>
          <v-flex xs6 left>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="320px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  label="Date from"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateFrom"
                @input="menu1 = false"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 left>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="320px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  label="Date to"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateTo"
                @input="menu1 = false"
                :min="dateFrom"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>
        <v-flex xs12>
          <v-btn color="primary" text @click="exportSalesData()" > Show Sales Data </v-btn>
        </v-flex>
        <v-flex xs12 v-if='showData'>
          <h1> Sales Export</h1>
          <p style="font-size: 26px;" class="my-4" v-html="getDateRange()"></p>
          <div class="colorGrey mb-5" v-if='salesData === "both" || salesData === "online"'>
            <h1> Total Online Sale</h1>
            <div class="circleSales borderGrey">${{totalOnlineSale}}</div>
          </div>
          <div class="colorPink mb-5" v-if='salesData === "both" || salesData === "offline"'>
            <h1> Total Offline Sale</h1>
            <div class="circleSales borderPink">${{totalOfflineSale}}</div>
            <v-flex>
              <div v-html="this.individualSales">
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-flex>
      <v-snackbar dark top v-model="snackbar" :timeout="3000">
        {{ popupText }}
        <v-btn dark flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
</template>

<script>
import OrderService from '@/services/OrderService'
import moment from 'moment'

export default {
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    salesData: 'both',
    teamMembers: [],
    availableUsers: [],
    availableUserIDs: [],
    individualSales: '',
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    menu1: false,
    menu2: false,
    snackbar: false,
    popupText: null,
    showData: false,
    totalOnlineSale: 0,
    totalOfflineSale: 0,
    availableSalesDatas: [
      { key: 'online', label: 'Online' },
      { key: 'offline', label: 'Offline' }
    ]
  }),
  mounted () {
    // console.log(this.loggedInUser)
    this.getOrderUsers()
  },
  methods: {
    getDateRange () {
      return moment(this.dateFrom).format('DD/MM/YYYY') + ' - ' + moment(this.dateTo).format('DD/MM/YYYY')
    },
    async exportSalesData () {
      let params = {salesData: this.salesData, teamMembers: this.teamMembers, dateFrom: this.dateFrom, dateTo: this.dateTo}
      // console.log(this.availableUserIDs)
      if (this.teamMembers.length === 0) {
        params = {salesData: this.salesData, teamMembers: this.availableUserIDs, dateFrom: this.dateFrom, dateTo: this.dateTo}
      }
      let response = await OrderService.exportSalesData(params)
      let orders = response.data.orders
      let onlineOrders = orders.filter(function (order) {
        return !order.createdBy
      })
      let offlineOrders = orders.filter(function (order) {
        return order.createdBy
      })
      // console.log(onlineOrders)
      // console.log(offlineOrders)
      this.totalOnlineSale = 0
      for (let index = 0; index < onlineOrders.length; index++) {
        let order = onlineOrders[index]
        let orderTotal = 0
        if (order.subTotal != null) {
          orderTotal += order.subTotal
        }
        if (order.shipping != null) {
          orderTotal += order.shipping
        }
        if (order.insurance != null) {
          orderTotal += order.insurance
        }
        if (order.install != null) {
          orderTotal += order.install
        }
        if (order.measure != null) {
          orderTotal += order.measure
        }
        if (order.discount != null) {
          orderTotal -= order.discount
        }

        this.totalOnlineSale = this.totalOnlineSale + orderTotal
      }
      this.totalOfflineSale = 0
      let individualSales = []
      for (let index = 0; index < offlineOrders.length; index++) {
        let order = offlineOrders[index]
        let orderTotal = 0
        if (order.subTotal != null) {
          orderTotal += order.subTotal
        }
        if (order.shipping != null) {
          orderTotal += order.shipping
        }
        if (order.insurance != null) {
          orderTotal += order.insurance
        }
        if (order.install != null) {
          orderTotal += order.install
        }
        if (order.measure != null) {
          orderTotal += order.measure
        }
        if (order.discount != null) {
          orderTotal -= order.discount
        }
        this.totalOfflineSale = this.totalOfflineSale + orderTotal

        if (order.updatedBy) {
          if (!individualSales[order.updatedBy.firstName]) {
            individualSales[order.updatedBy.firstName] = 0
          }
          individualSales[order.updatedBy.firstName] += orderTotal
        } else if (order.createdBy && !order.updatedBy) {
          if (!individualSales[order.createdBy.firstName]) {
            individualSales[order.createdBy.firstName] = 0
          }
          individualSales[order.createdBy.firstName] = parseFloat(individualSales[order.createdBy.firstName]) + orderTotal
        }
      }
      this.totalOnlineSale = this.numberWithCommas(parseFloat(this.totalOnlineSale).toFixed(2))
      this.totalOfflineSale = this.numberWithCommas(parseFloat(this.totalOfflineSale).toFixed(2))

      this.individualSales = `<table width="100%" class='salesIndividual'>
      <tr>
        <th width="50%">Team Members</th>
        <th width="50%">Sales</th>
      </tr>
      `
      individualSales = Object.entries(individualSales)
        .sort(([, a], [, b]) => b - a) // for asc a-b and desc b-a
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
      for (const [key, value] of Object.entries(individualSales)) {
        // console.log(`${key}: ${value}`);
        // this.individualSales = this.individualSales + `<div class='halfDiv'>${key}:</div><div class='halfDiv'> ${parseFloat(value).toFixed(2)}</div>`
        this.individualSales = this.individualSales + `<tr><td>${key}</td><td> ${this.numberWithCommas(parseFloat(value).toFixed(2))}</td></tr>`
      }
      this.individualSales = this.individualSales + `</table>`
      /* const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Sales Report ' + this.dateFrom + '__' + this.dateTo + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF Sales report generated'
      this.snackbar = true */
      this.showData = true
    },
    async getOrderUsers () {
      const totalUserResponse = await OrderService.usersOrders()
      let users = totalUserResponse.data.users
      let temp = []
      let userList = []
      users.map(function (value, key) {
        if (value.updatedBy) {
          if (!temp.includes(value.updatedBy._id) && value.updatedBy.firstName) {
            // console.log(value)
            userList.push({ id: value.updatedBy._id, firstName: value.updatedBy.firstName })
            temp.push(value.updatedBy._id)
          }
        } else if (value.createdBy && !value.updatedBy) {
          if (!temp.includes(value.createdBy._id) && value.createdBy.firstName) {
            // console.log(value)
            userList.push({ id: value.createdBy._id, firstName: value.createdBy.firstName })
            temp.push(value.createdBy._id)
          }
        }
      })
      this.availableUsers = userList
      this.availableUserIDs = temp
    },
    numberWithCommas (x) {
      if (x) {
        var parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      } else {
        return 0
      }
    }
  }
}
</script>

<style>
.radio-center { max-width: 360px; margin: 0 auto;}
.m0a { margin: 0 auto;}
.halfDiv { width: 50%; text-align: left; float: left; font-size: 24px;}
.circleSales {
    width: 250px;
    margin: 0 auto;
    border-radius: 50%;
    height: 250px;
    vertical-align: middle;
    line-height: 250px;
    font-size: 32px;
}
.salesIndividual td {
    padding: 15px;
    width: 20%;
    background: #565e6f;
    border-radius: 10px;
}
.salesIndividual {
    font-size: 28px;
    color: #fff;
}
.salesIndividual th {
    color: #ea4d76
}
.borderGrey {
  border: 3px solid #565e6f;
}
.colorGrey {
  color: #565e6f;
}
.borderPink {
  border: 3px solid #ea4d76;
}
.colorPink {
  color: #ea4d76;
}
</style>



// WEBPACK FOOTER //
// src/components/SalesExport.vue